import { Autocomplete, Avatar, Button, CircularProgress, Dialog, DialogActions, DialogContent, Grid, MenuItem, TextField, Typography } from "@mui/material";
import Sala from "../../../types/Sala";
import { ISimpleUser } from "../../config/Empleados";
import AddIcon from '@mui/icons-material/Add';
import { LocalizationProvider, DateTimePicker } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { Moment } from 'moment';
import { aDateOInvalida } from '../../../utils/FechaSelector';
import { createTheme } from '@mui/material/styles';
import IPaciente from "../../../types/Paciente";
import * as constantes from "../../../common/Constantes";
import Utilities from "../../../common/Utilities";

const locale = constantes.locale;

interface ClaseDialogProps {
  open: boolean;
  loading: boolean;
  onUpdate: () => void;
  onCancel: () => void;
  event: any;
  pacientes: IPaciente[];
  pacientesIds: IPaciente[];
  setPacientesIds: (pacientes: IPaciente[]) => void;
  pacienteId: string;
  profesorId: number;
  setProfesorId: (id: number) => void;
  sanitarios: ISimpleUser[];
  salas: Sala[];
  salaId: number;
  setSalaId: (id: number) => void;
  startClass: Date;
  setStartClass: (date: Date) => void;
  duracion: number;
  setDuracion: (duracion: number) => void;
}

const ClaseDialog = ({ 
    open,
    loading,
    onUpdate,
    onCancel,
    event,
    pacientes,
    pacientesIds,
    setPacientesIds,
    pacienteId,
    profesorId,
    setProfesorId,
    sanitarios,
    salas,
    salaId,
    setSalaId,
    startClass,
    setStartClass,
    duracion,
    setDuracion

 }: ClaseDialogProps) => {

    const theme = createTheme();

    return (
      <Dialog open={open} maxWidth="lg" fullWidth onClose={onCancel}>
        <DialogContent>
            <Typography variant="h4" sx={{ display: 'inline-flex' }}>
                <Avatar sx={{ margin: theme.spacing(1), backgroundColor: '#2e7d32' }}><AddIcon /></Avatar><div style={{ margin: '10px auto' }}>{`Modificar clase de ${event.title}`}</div>
            </Typography>
            <Grid container spacing={1}>
                <Grid item md={6}>
                    <Autocomplete
                        disablePortal
                        autoComplete
                        id="pacientes"
                        multiple
                        options={pacientes}
                        value={pacientesIds}
                        noOptionsText={'No se han encontrado pacientes'}
                        renderOption={(props, option) => { return (<li {...props} key={option._id}>{`${option.nombre} ${option.apellidos}`}</li>) }}
                        renderInput={(params) => <TextField required {...params} label="Pacientes" value={pacienteId} variant="outlined" margin="dense" fullWidth error={pacientesIds.length > event?.resource.capacity ? true : false} helperText={`${pacientesIds.length} de ${event?.resource.capacity} pacientes por clase`} />}
                        onChange={(event, value) => { value && setPacientesIds(value) }}
                        getOptionLabel={(option) => `${option.nombre} ${option.apellidos}` || ""}
                        filterOptions={(options, params) => Utilities.filterPacientesAutocomplete(options, params.inputValue)}
                    />
                </Grid>
                <Grid container item md={6} spacing={1}>
                    <Grid item md={6} xs={12}>
                        <TextField select value={profesorId} variant="outlined" label="Especialista" margin="dense" fullWidth required onChange={(event) => setProfesorId(parseInt(event.target.value))} >
                        {sanitarios
                            .filter(({ activo, internalID }) => activo || internalID === profesorId) // Mostrar solo los activos o el seleccionado
                            .map(({ internalID, firstName, activo }) => (
                              <MenuItem
                                key={internalID}
                                value={internalID}
                                disabled={internalID === profesorId && !activo} // Deshabilitar si está seleccionado y no activo
                              >
                                {firstName}
                              </MenuItem>
                        ))}
                        </TextField>
                    </Grid>
                    <Grid item md={6} xs={12}>
                        <TextField select value={salaId} variant="outlined" label="Sala" margin="dense" fullWidth required onChange={(event) => setSalaId(parseInt(event.target.value))} >
                            {
                                salas.map((sala: any) => {
                                    return (
                                        <MenuItem key={sala.internalID} value={sala.internalID}>{sala.title}</MenuItem>
                                    );
                                })
                            }
                        </TextField>
                    </Grid>
                    <Grid item md={6} xs={12} sx={{ marginTop: 1 }}>
                        <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale={locale}>
                            <DateTimePicker
                                renderInput={(props: any) => <TextField required fullWidth {...props} />}
                                label="Fecha y hora de inicio"
                                toolbarFormat="dd-mm-yyyy"
                                value={startClass}
                                ampm={false}
                                onChange={(date: Moment | null) => setStartClass(aDateOInvalida(date))}
                            />
                        </LocalizationProvider>
                    </Grid>
                    <Grid item md={6} xs={12}>
                        <TextField select value={duracion} variant="outlined" label="Duración" margin="dense" fullWidth required onChange={(event) => setDuracion(parseInt(event.target.value))} >
                            {
                                constantes.duracion.map((item, index) => {
                                    return (
                                        <MenuItem key={index} value={item}>{`${item.toString()} minutos`}</MenuItem>
                                    );
                                })
                            }
                        </TextField>
                    </Grid>
                </Grid>
            </Grid>
        </DialogContent>
        {loading ?
            <Grid container>
                <CircularProgress style={{ margin: '20px auto' }} />
            </Grid> :
            <DialogActions>
                <Button onClick={onUpdate}>Guardar</Button>
                <Button onClick={onCancel}>Cancelar</Button>
            </DialogActions>
        }
    </Dialog>
    );
};

export default ClaseDialog;